import { enUS as dfnEn, fr as dfnFr } from 'date-fns/locale';
import { I18n } from 'i18n-js';
import type { TranslateOptions } from 'i18n-js';

import en from './locales/en.json';
import fr from './locales/fr.json';
import type { Leaves, LocalizedDictionary } from './types';
import { getConfig } from '../../config';
import { storage } from '../storage/storage';

const supportedLocales = ['fr', 'en'] as const;
export type SupportedLocales = (typeof supportedLocales)[number];

const dateFnsLocales = { fr: dfnFr, en: dfnEn };

let _i18n: I18n | null = null;

const getI18n = () => {
  if (!_i18n) {
    _i18n = new I18n({ en, fr });

    const initialLocale =
      supportedLocales.find(l =>
        (getConfig().forceLocale || storage.getItem('locale') || getConfig().systemLocale || '').startsWith(l),
      ) || 'en';

    _i18n.defaultLocale = 'en';
    _i18n.enableFallback = true;
    _i18n.locale = initialLocale;
  }
  return _i18n;
};

export const getDateLocale = () => dateFnsLocales[getLocale()];

export const t = (key: Leaves<LocalizedDictionary>, options?: TranslateOptions) => getI18n().t(key, options);
export const tPlural = (key: string, options?: TranslateOptions) => getI18n().t(key, options);
export const getLocale = () => getI18n().locale as SupportedLocales;
export const setLocale = (newLocale: SupportedLocales) => {
  storage.setItem('locale', newLocale);

  getConfig().reloadSystem();
};
